import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Localiser } from '../../services/localiser';
import { Navigation } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';
import {DeviceService} from "../../services/device.service";
import {ProyectoService} from "../../services/proyecto.service";
import {last} from "rxjs/operators";
import {Roles} from '../../commons/util';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  public situation: string;

  constructor(public localiser: Localiser, private navigation: Navigation, public user: UserService,
              private deviceService: DeviceService, public proyectoService: ProyectoService) { }

  ngOnInit(): void {
    let situationCom = this.navigation.getSituation();
    this.situation = situationCom.situation;
  }

  changeLanguage(language) {
    if (language == "English") {
      this.localiser.load("en");
    } else {
      this.localiser.load("es");
    }
  }

  logOut() {
    this.user.logOut();
    this.navigation.toLogin();
  }

  toHome() {
    this.navigation.toHome();
  }

  toLocations(lastPage: boolean) {
    if (!lastPage)
      this.proyectoService.setLastPage("");
    this.navigation.toLocations();
  }

  toIndicators() {
    this.navigation.toIndicators();
  }

  toFloorplans() {
    this.navigation.toSelectFloorplan();
  }

  toAteneoZones() {
    this.navigation.toAteneoZones();
  }

  toDevices() {
    this.deviceService.nothingSelect();
    this.navigation.toDevices();
  }

  toAlerts() {
    this.navigation.toAlerts();
  }

  toAirfal() {
    this.navigation.toAirfal();
  }

  toUsers() {
    this.navigation.toUsers();
  }

  toReglas() {
    this.navigation.toReglas();
  }

  toFade() {
    this.navigation.toFade();
  }

  toProfile() {
    this.navigation.toProfile();
  }

  toLimits() {
    this.navigation.toLimits();
  }

  toOta() {
    this.navigation.toOta();
  }

  toAutotest() {
    this.navigation.toAutotest();
  }

  toReports() {
    this.navigation.toReports();
  }

  toParameters() {
    this.navigation.toParameters();
  }

  public readonly Roles = Roles;
}
